import store from "../store";
import { commonService } from "./common.service";
import { env } from "../env";

export const aerogenerateurService = {
  getAerogenerateursParc,
  getConstructeurs,
  getReferencesModeles,
  postAerogenerateur,
  putAerogenerateur,
  deleteAerogenerateur
};

function getAerogenerateursParc(parcId) {
  const url = new URL(`${env.apiUrl}/aerogenerateurs/parcs/${parcId}`);

  return commonService.getRessource(url).then(eoliennes => {
    eoliennes.forEach(eolienne => {
      eolienne.isAllumage = eolienne.periodeAllumage !== null;
    });
    return eoliennes;
  });
}

function getConstructeurs() {
  const url = new URL(`${env.apiUrl}/constructeurs`);

  return commonService.getRessource(url);
}

function getReferencesModeles(constructeurId) {
  const url = new URL(`${env.apiUrl}/reference-modeles/constructeurs/${constructeurId}`);

  return commonService.getRessource(url);
}

function postAerogenerateur(aerogenerateur) {
  if (!aerogenerateur.isAllumage) {
    aerogenerateur.periodeAllumage = null;
    aerogenerateur.typeFeu = null;
  }

  const url = new URL(`${env.apiUrl}/aerogenerateurs`);

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + store.getters.token,
    },
    body: JSON.stringify(aerogenerateur)
  };

  return fetch(url, requestOptions)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}

function putAerogenerateur(aerogenerateur) {
  if (!aerogenerateur.isAllumage) {
    aerogenerateur.periodeAllumage = null;
    aerogenerateur.typeFeu = null;
  }

  const url = new URL(`${env.apiUrl}/aerogenerateurs`);

  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + store.getters.token,
    },
    body: JSON.stringify(aerogenerateur)
  };

  return fetch(url, requestOptions)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}

function deleteAerogenerateur(aerogenerateurId) {
  const url = new URL(`${env.apiUrl}/aerogenerateurs/${aerogenerateurId}`);

  const requestOptions = {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + store.getters.token,
    }
  };

  return fetch(url, requestOptions)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}
